<div class="chat-container">
  @if (currentClient && currentUser) { @if (!hasUserAcceptedTermsAndConditions)
  {
  <div class="focus-ai-content">
    <div class="focus-ai-legal">
      <label>AI Content Generation Reminder</label>
      <p class="focus-ai-legal-text">
        By using this AI feature, you acknowledge and agree that all data
        entered into the system is considered Client Data and subject to the
        terms and conditions of the agreement between your company and Relay.
      </p>
      <p class="focus-ai-legal-text">
        <span class="focus-ai-legal-section">User Responsibility: </span>You are
        solely responsible for the ethical, legal, and compliant use of all
        AI-generated content.
      </p>
      <p class="focus-ai-legal-text">
        <span class="focus-ai-legal-section">Financial Data Restrictions: </span
        >Do not upload files containing credit card numbers, account numbers,
        SSNs, routing numbers, or other sensitive financial information.
      </p>
      <p class="focus-ai-legal-text">
        <span class="focus-ai-legal-section">Content Limitations: </span
        >AI-generated content may contain errors, inaccuracies, or biases. Human
        oversight is required. We provide this tool without warranties and are
        not liable for consequences from generated content use.
      </p>
      <p class="focus-ai-legal-text-italic">
        By proceeding, you agree to all terms above. We reserve the right to
        modify these terms as needed.
      </p>
      <p class="focus-ai-legal-text-italic">
        Note: Chat history and citations are not saved after the Content Pro
        window is closed.
      </p>
    </div>
    <div class="focus-ai-buttons">
      <button
        data-testid="cancel-contentpro-tscs-btn"
        class="btn btn-link cancel"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button
        data-testid="accept-contentpro-tscs-btn"
        class="btn btn-primary continue"
        (click)="acceptAndContinueToContentPro()"
      >
        Continue
      </button>
    </div>
  </div>
  } @if (hasUserAcceptedTermsAndConditions) {
  <div class="chat-instructions">
    <p>
      Content Pro will help you generate a message based on materials you
      provided in the
      <a class="to-content-pro-repo" href="/content-pro-library" target="_blank"
        >Content Pro Library</a
      >. Describe your message below and chat to refine.
    </p>
  </div>
  <div class="chat-messages" #chatMessages>
    <div class="welcome-message">
      <div class="welcome-header">
        <div class="welcome-icon">
          <i class="fa-solid fa-sparkles"></i>
        </div>
        <h3>Welcome to Content Pro!</h3>
      </div>
      <div class="welcome-content">
        @if (hasContentProFiles) {
        <p>
          Tell me what kind of Feed message you'd like to create. You can
          include the topic, audience, tone, and any specific content you want
          me to use—or avoid—from your library. I'll draft a message using your
          approved materials.
        </p>
        } @else {
        <p>
          Tell me what kind of Feed message you'd like to create. You can
          include the topic, audience, tone, and I'll draft a message for you.
        </p>
        <p class="library-note">
          This feature works best when your Content Pro Library is populated.
          You can still continue without it, or
          <a
            href="/content-pro-library"
            target="_blank"
            class="inline-library-link"
          >
            add content to your library
          </a>
          to get more on-brand, tailored results.
        </p>
        }
      </div>
    </div>
    @for (message of conversation; track $index) { @if (message.type === 'user')
    {
    <div class="user-message">
      <div class="message-bubble user-bubble">
        {{ message.content }}
      </div>
    </div>
    } @else if (message.type === 'ai') {
    <div class="ai-message">
      <div class="ai-message-content">
        <div class="message-bubble ai-bubble">
          {{ message.content }}
        </div>
        @if (message.citations && message.citations.length > 0) {
        <rn-citation-collapsoid
          [citations]="message.citations"
        ></rn-citation-collapsoid>
        }
      </div>
    </div>
    } } @if (isGenerating) {
    <div class="ai-message">
      <div class="message-bubble ai-bubble typing-indicator">
        <span></span><span></span><span></span>
      </div>
    </div>
    }
  </div>
  <div class="chat-input-container">
    <div class="chat-input-wrapper">
      <textarea
        id="contentProPrompt"
        class="form-control chat-input"
        rows="1"
        placeholder="Describe the message you'd like to create..."
        [formControl]="prompt"
        (keydown.enter)="
          $event.preventDefault(); !$event.shiftKey && sendMessage()
        "
        (input)="autoExpandTextarea($event)"
      ></textarea>
      @if (isGenerating) {
      <button
        data-testid="stop-contentpro-msg-btn"
        class="btn send-button"
        type="button"
        (click)="stopGeneration()"
      >
        <i class="fa-solid fa-stop"></i>
      </button>
      } @else {
      <button
        data-testid="send-contentpro-msg-btn"
        class="btn btn-primary send-button"
        type="button"
        (click)="sendMessage()"
        [disabled]="!prompt.value?.trim()"
      >
        <i class="fa-solid fa-paper-plane"></i>
      </button>
      }
    </div>
  </div>
  } }
</div>
